import { ITemplateResponse, TConvertKeys, TNullable } from './common';
import { TUserSummary } from './user';

export enum ECallRequestStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export interface ICallRequestAppointment {
  institution_service_id: string;
  patient: TNullable<TUserSummary>;
}

export interface ICallRequest {
  id: string;
  appointment_id: string;
  appointment?: ICallRequestAppointment;
  caller_user_institution_role_id: string;
  callee_user_institution_role_id: string;
  caller?: TUserSummary;
  callee?: TUserSummary;
  status: ECallRequestStatus;
  expires_at: string;
  resolved_at: TNullable<string>;
  created_at: string;
}

export type TCallRequestCamel = TConvertKeys<ICallRequest>;

export interface ICreateCallRequestRequest {
  appointment_id: string;
  user_institution_role_id: string;
}

export type ICallRequestResponse = ITemplateResponse<ICallRequest>;
export type IListCallRequestsResponse = ITemplateResponse<ICallRequest[]>;
